export default function akamaiImageUrl(url) {
  if (typeof url === 'string') {
    return url.replace(/s3.ap-southeast-2.amazonaws.com\/(([^.]{3}.)?multitools.newscdn.com.au)/, '$1');
  }
  return url;
}
